var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-audio-recorder",class:{
      'active': _vm.isRecording
    },on:{"click":_vm.toggleRecorder}},[_c('br'),_vm._v(_vm._s(this.recording)),_c('br'),_vm._v(_vm._s(this.recorderState)),_c('br'),(!_vm.isRecording)?_c('span'):_c('i',{class:{
    'ni ni-button-pause': _vm.isRecording},staticStyle:{"font-size":"1.5rem","color":"#fff","padding":"1.1rem"}})])}
var staticRenderFns = []

export { render, staticRenderFns }